export default {"src":"/_next/static/media/message.9fbbace2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};